import React from 'react';

function NotificationCard({ notifications }) {
    return (
        <div className="container mx-auto p-4">
            {notifications.map((notification) => (
                <div
                    key={notification.id}
                    className="flex flex-col border-2 border-slate-100 rounded-xl p-4 gap-3 mb-4 bg-white shadow-sm"
                >
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
                        <h4 className="text-base sm:text-lg md:text-xl font-medium">
                            {notification.heading}
                        </h4>
                        <small className="text-xs sm:text-sm md:text-base font-medium text-[#05BF02] mt-2 sm:mt-0">
                            {new Date(notification.created_at).toLocaleString('en-US', {
                                month: '2-digit',
                                day: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: true,
                            })}
                        </small>
                    </div>
                    <p className="text-sm sm:text-base text-gray-500">
                        {notification.message}
                    </p>
                </div>
            ))}
        </div>
    );
}

export default NotificationCard;
